<div class="flex flex-col h-full bg-white overflow-hidden" (mousedown)="onPageMouseDown($event)">
  <main class="flex-1 p-5 overflow-hidden">
    <div class="bg-gris-4 rounded-[10px] h-full flex items-center justify-center">
      <div class="flex flex-col items-center gap-6">
        <!-- Zone scanner -->
        <div
          class="bg-white border-2 border-dashed border-vert-1 rounded-[14px] h-[191px] w-[175px] flex items-center justify-center">
          <div class="flex flex-col items-center gap-2">
            <img src="assets/images/icones/badge-scanner.png" alt="scanner" class="size-[53px] object-contain" />
            <p class="fg-gris-1 text-[11px] text-center leading-[16.5px] p-2">
              {{ 'scan_page.scan_badge' | translate }}
            </p>
          </div>
        </div>

        <!-- Titre -->
        <h2 class="fg-noir-1 text-[19px] font-bold text-center m-0">
          {{ 'scan_page.scan_badge' | translate }}
        </h2>

        <!-- Séparateur -->
        <div class="flex items-center gap-4 w-[320px]">
          <div class="flex-1 h-px bg-gris-1"></div>
          <span class="fg-gris-1 text-[11px] font-bold uppercase">
            {{ 'common.or' | translate }}
          </span>
          <div class="flex-1 h-px bg-gris-1"></div>
        </div>

        <!-- Barre de recherche -->
        <div class="flex h-[58px]">
          <input #searchInput type="text" [(ngModel)]="searchQuery" (keyup.enter)="onSearch()"
            (blur)="onSearchInputBlur($event)" placeholder="{{ 'scan_page.search_placeholder' | translate }}"
            class="bg-white border border-gris-3 border-r-0 rounded-l-[5px] px-5 w-[319px] fg-noir-2 text-[16px] outline-none" />
          <button (click)="onSearch()" [disabled]="isLoading()"
            class="bg-vert-1 border border-gris-4 rounded-r-[5px] px-5 text-white text-[16px] font-semibold whitespace-nowrap cursor-pointer hover:brightness-95 transition-colors disabled:opacity-60 disabled:cursor-not-allowed">
            {{ isLoading() ? ('common.loading' | translate) : ('common.search' | translate) }}
          </button>
        </div>
      </div>
    </div>
  </main>
</div>

@if (showPassageValidatedModal()) {
<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
  <app-modal-confirmation class="w-[500px]" [imageUrl]="'assets/images/icones/valid.png'"
    [title]="'scan_page.checkin_validated_title' | translate" [highlightText]="validatedCustomerName()"
    [countdownText]="'modal.validated_order.countdown' | translate: { seconds: 3 }"
    [buttonLabel]="'common.confirm' | translate" (buttonClick)="onModalButtonClick()" />
</div>
}